import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';

import { Config } from '../entities/entities';

@Injectable()
export class ConfigService {

    public Current: Config = null;

    constructor(private http: Http) { }

    public loadConfig(): Promise<Config> {
        let promise = this.http.get('config.json').pipe(
            map((response) => response.json()),
            ).toPromise();

        promise.then((config) => {
            this.Current = config;
        });

        // it's important to return promise here, b/c ng will wait for this promise to 
        // resolve before loading the rest of the app.
        return promise;
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/src/app/services/config.service.ts